import {
  ChangeEventHandler,
  FocusEvent,
  FocusEventHandler,
  MouseEventHandler,
  useRef,
} from "react";

type DateInputProps = {
  type?: "date" | "datetime-local";
  value: string;
  placeholder?: string;
  onChange: ChangeEventHandler<HTMLInputElement>;
  onClear?: MouseEventHandler<HTMLDivElement>;
  onBlur?: FocusEventHandler<HTMLInputElement>;
  label?: string;
  id?: string;
  name?: string;
  minDate?: string;
  maxDate?: string;
  disabled?: boolean;
  showPickerOnFocus?: boolean;
};

const DateInput = (props: DateInputProps) => {
  const {
    type = "date",
    value,
    placeholder,
    onChange,
    onBlur,
    id,
    name,
    minDate,
    maxDate,
    disabled = false,
    showPickerOnFocus = false,
  } = props;

  const inputMaxDate = maxDate
    ? maxDate
    : type === "date"
    ? "9999-12-31"
    : "9999-12-31T00:00:00";

  const inputRef = useRef<HTMLInputElement>(null);

  return (
    <input
      type={placeholder && !value ? "text" : type}
      ref={inputRef}
      placeholder={placeholder}
      onChange={onChange}
      onFocus={() => {
        if (inputRef.current) {
          if (placeholder) {
            inputRef.current.type = type;
          }
          if (showPickerOnFocus) {
            //@ts-ignore
            inputRef.current.showPicker();
          }
        }
      }}
      onBlur={(e: FocusEvent<HTMLInputElement>) => {
        onBlur && onBlur(e);
        if (inputRef.current && !value && placeholder)
          inputRef.current.type = "text";
      }}
      value={value}
      min={minDate}
      max={inputMaxDate}
      name={name}
      id={id}
      autoComplete="off"
      disabled={disabled}
    />
  );
};

export default DateInput;
